import {
  CustomerFeedbackFormValues,
  NewChatFormValues,
  SendMessageFormValues,
  WiseOwlIngress,
  WiseOwlContextProps,
} from "@twiliointernal/e2-commons-shared-definitions";

const defaultWiseOwlContext: WiseOwlContextProps = {
  applicationProps: {
    displayName: "Help Center Assistant",
    ingress: WiseOwlIngress.osc,
    user: {
      firstName: "M",
      lastName: "E",
    },
  },
  author: "M E",
  isLoggedIn: false,
  isLiveChatPreEngagementOpen: false,
  ingress: WiseOwlIngress.osc,
  loadingConfiguration: {
    fetchChatById: false,
    submission: false,
  },
  handlers: {
    handleRedirectAction: (redirectUrl: string) => Promise.resolve(),
    handleSubmitFeedback: (data: CustomerFeedbackFormValues) =>
      Promise.resolve(),
    handleStartNewChat: (data: NewChatFormValues) => Promise.resolve(),
    handleSendChatMessage: (data: SendMessageFormValues) => Promise.resolve(),
  },
  experimentFlags: {},
  meta: { initialized: false },
};

export { defaultWiseOwlContext };
